import React, { useState, useMemo, useEffect } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';

import componentFunctions from '../../../../../services/tools/componentFunctions';
import * as tnaServices from '../../../../../services/tnaServices';
import css from './TnaModulesOverview.module.css';

import toShort from '../../../../../services/utils/dateParser';
import SearchBar from '../../../_common/elements/search-bar/SearchBar';

function TnaModulesOverview() {
    const [filter, setFilter] = useState('');
    const [data, setData] = useState([]);
    const [sortConfig, setSortConfig] = useState(componentFunctions.sortConfig);
    const requestSort = (key) => componentFunctions.requestSort(key, sortConfig, setSortConfig);
    const navigate = useNavigate();

    useEffect(() => {
        tnaServices
            .getAllModules(1)
            .then((res) => {
                // console.log(res);
                setData(res.data);
            })
            .catch((err) => {
                console.error('Error fetching certificate issue data:', err);
            });
    }, []);

    const sortedAndFilteredData = useMemo(() => {
        return componentFunctions.sortedAndFilteredData(data, sortConfig, filter);
    }, [data, sortConfig, filter]);

    if (!data || !data.length) {
        return <p>No data available.</p>;
    }

    // ---------------------------------------
    const headers = Object.keys(data[0]);
    //-------------------------------------

    // console.log(caller);

    return (
        <>
            <SearchBar filter={filter} setFilter={setFilter} sortedAndFilteredData={sortedAndFilteredData} />
            {/* <div style={{ textAlign: 'right', marginTop: '5px', color: 'red', fontSize: '1.2rem' }}>
                <label>
                    Show Closed?
                    <input type="checkbox" onChange={handleShowClosedFilter} value={showClosed} />
                </label>
                <label>
                    Show Cancelled?
                    <input type="checkbox" onChange={handleShowCancelledFilter} value={showCancelled} />
                </label>
            </div> */}
            <h2>TNA Modules</h2>
            <table className={css.table}>
                <thead className={css.thead}>
                    <tr>
                        <th onClick={() => requestSort(data.tnaModuleId)} className={css.th}>
                            Module ID
                            {/* {sortConfig.key === data.courseNo ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.tnaModuleTitle)} className={css.th}>
                            Title
                            {/* {sortConfig.key === data.studentNo ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.tnaModuleNo)} className={css.th}>
                            No
                            {/* {sortConfig.key === data.studentNo ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.tnaModuleRevNo)} className={css.th}>
                            Rev
                            {/* {sortConfig.key === data.studentName ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.tnaModuleRevDate)} className={css.th}>
                            Date
                            {/* {sortConfig.key === data.studentName ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>
                        <th onClick={() => requestSort(data.tnaModuleNote)} className={css.th}>
                            Note
                            {/* {sortConfig.key === data.studentName ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''} */}
                        </th>

                        {/* <th></th> */}
                    </tr>
                </thead>
                <tbody className={css.tbody}>
                    {sortedAndFilteredData.length > 0 ? (
                        sortedAndFilteredData.map((x, index) => (
                            <tr
                                key={x.tnaModuleId}
                                id={x.tnaModuleId}
                                onClick={() => navigate('/tna/modules/details/' + x.tnaModuleId)}
                                className={`${css.row} ${x.tnaModuleIsForDiff ? css.diffRow : ''}`}
                            >
                                <td className={css.td}>{x.tnaModuleId}</td>
                                <td className={css.td}>{x.tnaModuleTitle}</td>

                                <td className={css.td}>
                                    <Link to={`/tna/details/${x.tnaModuleNo}`} className={css.link}>
                                        {x.tnaModuleNo}
                                    </Link>
                                </td>

                                <td className={css.td}>{x.tnaModuleRevNo}</td>

                                <td className={css.tdWide} style={x.tnaModuleRevDate === '01-Jan-1900' ? { color: 'red' } : {}}>
                                    {x.tnaModuleRevDate}
                                </td>
                                <td className={css.td}>{x.tnaModuleNote}</td>
                                {/* <td className={css.tdWide} style={x.courseEnd === '01-Jan-1900' ? { color: 'red' } : {}}>
                                    {toShort(x.courseEnd)}
                                </td> */}

                                {/* <td className={css.td}>{x.requestId}</td> */}

                                {/* <td className={css.td}>
                                    {x.certificateLink && (
                                        <Link to={x.certificateLink} target="_blank" rel="noopener noreferrer">
                                            <i className="fa-solid fa-award"></i>
                                        </Link>
                                    )}
                                </td> */}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                                No matching records found. Please adjust your filter.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
}

export default TnaModulesOverview;
